import { makeModalsHook } from 'shared/functions/makeModalsHook';

export const usePortfolioModals = makeModalsHook(
  'createPortfolio',
  'addToPortfolio',
  'requestEsgScore',
  'createCompanies',
);
